export default __webpack_public_path__ + "static/media/img-intro.de5c8c0f.png";